/**
 * Hashes a CoreMedia site name for the X-Site-Hash header (anti-enumeration check on
 * retrieveMenuTree). SHA-256 truncated to 16 hex characters — matches the backend's
 * SiteHashUtil so both sides derive the same value for the same site name.
 */
export async function computeSiteHash(siteName: string): Promise<string> {
  const normalized = siteName.trim().toLowerCase();
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(normalized),
  );
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("")
    .slice(0, 16);
}
